import { render, staticRenderFns } from "./TiemposPorZona.vue?vue&type=template&id=33452c1a&scoped=true"
import script from "./TiemposPorZona.vue?vue&type=script&lang=js"
export * from "./TiemposPorZona.vue?vue&type=script&lang=js"
import style0 from "./TiemposPorZona.vue?vue&type=style&index=0&id=33452c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33452c1a",
  null
  
)

export default component.exports